// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-interactions {
    position: relative;
    overflow: hidden;
    margin: 20px 0;
    padding: 22px 22px 26px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(
        165deg,
        rgba(58, 58, 58, 0.92) 0%,
        rgba(38, 38, 38, 0.97) 55%,
        rgba(30, 30, 30, 1) 100%
    );
    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.24),
        inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.device-interactions::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
        90deg,
        rgba(192, 159, 83, 0.25),
        rgba(192, 159, 83, 0.8),
        rgba(192, 159, 83, 0.25)
    );
    pointer-events: none;
}

.device-interactions__header {
    margin-bottom: 18px;
    text-align: center;
}

.device-interactions__title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: rgb(240, 240, 240);
    letter-spacing: -0.02em;
}

.device-interactions__subtitle {
    margin: 6px 0 0 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.38);
    letter-spacing: 0.03em;
}

.device-interactions__lead {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    padding: 6px 14px;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.88);
    background: rgba(192, 159, 83, 0.12);
    border: 1px solid rgba(192, 159, 83, 0.35);
}

.device-interactions__body {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr);
    gap: 24px 28px;
    align-items: center;
}

@media screen and (max-width: 900px) {
    .device-interactions__body {
        grid-template-columns: 1fr;
        justify-items: center;
    }
}

/* Donut */
.device-interactions__donut-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
}

.device-interactions__donut {
    position: relative;
    width: 168px;
    height: 168px;
    border-radius: 50%;
    flex-shrink: 0;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.35);
}

.device-interactions__donut-hole {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 52%;
    height: 52%;
    border-radius: 50%;
    background: linear-gradient(180deg, rgba(42, 42, 42, 0.98) 0%, rgba(28, 28, 28, 1) 100%);
    border: 1px solid rgba(255, 255, 255, 0.06);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 8px;
}

.device-interactions__donut-hole-label {
    font-size: 0.58rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.35);
}

.device-interactions__donut-hole-value {
    margin-top: 4px;
    font-size: 0.95rem;
    font-weight: 700;
    color: rgb(245, 245, 245);
    line-height: 1.15;
}

.device-interactions__donut-hole-sub {
    margin-top: 2px;
    font-size: 0.65rem;
    color: rgba(255, 255, 255, 0.4);
    max-width: 8rem;
    line-height: 1.25;
}

.device-interactions__legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px 16px;
    margin: 0;
    padding: 0;
    list-style: none;
}

.device-interactions__legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.78rem;
    color: rgba(255, 255, 255, 0.78);
}

.device-interactions__legend-swatch {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    flex-shrink: 0;
}

/* Stacked bar */
.device-interactions__stack {
    width: 100%;
    max-width: 520px;
    margin: 0 auto;
    grid-column: 1 / -1;
}

.device-interactions__stack-label {
    margin: 0 0 8px 0;
    font-size: 0.62rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
    text-align: center;
}

.device-interactions__stack-track {
    display: flex;
    height: 14px;
    border-radius: 999px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.06);
}

.device-interactions__stack-seg {
    min-width: 0;
    height: 100%;
    transition: width 0.35s ease;
    position: relative;
}

.device-interactions__stack-seg:first-child {
    border-radius: 999px 0 0 999px;
}

.device-interactions__stack-seg:last-child {
    border-radius: 0 999px 999px 0;
}

.device-interactions__stack-seg:only-child {
    border-radius: 999px;
}

/* Device rows */
.device-interactions__rows {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    min-width: 0;
}

.device-interactions__row {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 12px 14px;
    align-items: center;
    padding: 12px 14px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: border-color 0.2s ease, background 0.2s ease;
}

.device-interactions__row:hover {
    border-color: rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.24);
}

.device-interactions__row-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.85);
}

.device-interactions__row-icon svg {
    width: 20px;
    height: 20px;
    opacity: 0.92;
}

.device-interactions__row-main {
    min-width: 0;
}

.device-interactions__row-label {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 6px;
}

.device-interactions__row-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: rgb(236, 236, 236);
}

.device-interactions__row-pct {
    font-size: 0.88rem;
    font-weight: 700;
    color: rgba(192, 159, 83, 0.95);
    font-variant-numeric: tabular-nums;
}

.device-interactions__row-bar {
    height: 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    overflow: hidden;
}

.device-interactions__row-bar-fill {
    height: 100%;
    border-radius: 999px;
    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.device-interactions__row-side {
    text-align: right;
    min-width: 4.5rem;
}

.device-interactions__row-count {
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgb(245, 245, 245);
    font-variant-numeric: tabular-nums;
}

.device-interactions__row-count-label {
    display: block;
    margin-top: 2px;
    font-size: 0.62rem;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.35);
}

.device-interactions__empty {
    margin: 0;
    padding: 24px;
    text-align: center;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Charts/DeviceTypeInteractions/DeviceTypeInteractions.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C;;;;;KAKC;IACD;;+CAE2C;AAC/C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX;;;;;KAKC;IACD,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,uDAAuD;IACvD,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;AACJ;;AAEA,UAAU;AACV;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wFAAwF;IACxF,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,+BAA+B;IAC/B,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,2CAA2C;IAC3C,wDAAwD;AAC5D;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,qCAAqC;IACrC,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC","sourcesContent":[".device-interactions {\n    position: relative;\n    overflow: hidden;\n    margin: 20px 0;\n    padding: 22px 22px 26px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(\n        165deg,\n        rgba(58, 58, 58, 0.92) 0%,\n        rgba(38, 38, 38, 0.97) 55%,\n        rgba(30, 30, 30, 1) 100%\n    );\n    box-shadow:\n        0 8px 32px rgba(0, 0, 0, 0.24),\n        inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.device-interactions::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(\n        90deg,\n        rgba(192, 159, 83, 0.25),\n        rgba(192, 159, 83, 0.8),\n        rgba(192, 159, 83, 0.25)\n    );\n    pointer-events: none;\n}\n\n.device-interactions__header {\n    margin-bottom: 18px;\n    text-align: center;\n}\n\n.device-interactions__title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: rgb(240, 240, 240);\n    letter-spacing: -0.02em;\n}\n\n.device-interactions__subtitle {\n    margin: 6px 0 0 0;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.38);\n    letter-spacing: 0.03em;\n}\n\n.device-interactions__lead {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 12px;\n    padding: 6px 14px;\n    border-radius: 999px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.88);\n    background: rgba(192, 159, 83, 0.12);\n    border: 1px solid rgba(192, 159, 83, 0.35);\n}\n\n.device-interactions__body {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr);\n    gap: 24px 28px;\n    align-items: center;\n}\n\n@media screen and (max-width: 900px) {\n    .device-interactions__body {\n        grid-template-columns: 1fr;\n        justify-items: center;\n    }\n}\n\n/* Donut */\n.device-interactions__donut-wrap {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 14px;\n}\n\n.device-interactions__donut {\n    position: relative;\n    width: 168px;\n    height: 168px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.35);\n}\n\n.device-interactions__donut-hole {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 52%;\n    height: 52%;\n    border-radius: 50%;\n    background: linear-gradient(180deg, rgba(42, 42, 42, 0.98) 0%, rgba(28, 28, 28, 1) 100%);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 8px;\n}\n\n.device-interactions__donut-hole-label {\n    font-size: 0.58rem;\n    font-weight: 600;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.35);\n}\n\n.device-interactions__donut-hole-value {\n    margin-top: 4px;\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: rgb(245, 245, 245);\n    line-height: 1.15;\n}\n\n.device-interactions__donut-hole-sub {\n    margin-top: 2px;\n    font-size: 0.65rem;\n    color: rgba(255, 255, 255, 0.4);\n    max-width: 8rem;\n    line-height: 1.25;\n}\n\n.device-interactions__legend {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px 16px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.device-interactions__legend-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.78rem;\n    color: rgba(255, 255, 255, 0.78);\n}\n\n.device-interactions__legend-swatch {\n    width: 10px;\n    height: 10px;\n    border-radius: 3px;\n    flex-shrink: 0;\n}\n\n/* Stacked bar */\n.device-interactions__stack {\n    width: 100%;\n    max-width: 520px;\n    margin: 0 auto;\n    grid-column: 1 / -1;\n}\n\n.device-interactions__stack-label {\n    margin: 0 0 8px 0;\n    font-size: 0.62rem;\n    font-weight: 600;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n    text-align: center;\n}\n\n.device-interactions__stack-track {\n    display: flex;\n    height: 14px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: rgba(0, 0, 0, 0.35);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.device-interactions__stack-seg {\n    min-width: 0;\n    height: 100%;\n    transition: width 0.35s ease;\n    position: relative;\n}\n\n.device-interactions__stack-seg:first-child {\n    border-radius: 999px 0 0 999px;\n}\n\n.device-interactions__stack-seg:last-child {\n    border-radius: 0 999px 999px 0;\n}\n\n.device-interactions__stack-seg:only-child {\n    border-radius: 999px;\n}\n\n/* Device rows */\n.device-interactions__rows {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    width: 100%;\n    min-width: 0;\n}\n\n.device-interactions__row {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    gap: 12px 14px;\n    align-items: center;\n    padding: 12px 14px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.18);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.device-interactions__row:hover {\n    border-color: rgba(255, 255, 255, 0.1);\n    background: rgba(0, 0, 0, 0.24);\n}\n\n.device-interactions__row-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    color: rgba(255, 255, 255, 0.85);\n}\n\n.device-interactions__row-icon svg {\n    width: 20px;\n    height: 20px;\n    opacity: 0.92;\n}\n\n.device-interactions__row-main {\n    min-width: 0;\n}\n\n.device-interactions__row-label {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 6px;\n}\n\n.device-interactions__row-name {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: rgb(236, 236, 236);\n}\n\n.device-interactions__row-pct {\n    font-size: 0.88rem;\n    font-weight: 700;\n    color: rgba(192, 159, 83, 0.95);\n    font-variant-numeric: tabular-nums;\n}\n\n.device-interactions__row-bar {\n    height: 6px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.08);\n    overflow: hidden;\n}\n\n.device-interactions__row-bar-fill {\n    height: 100%;\n    border-radius: 999px;\n    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.device-interactions__row-side {\n    text-align: right;\n    min-width: 4.5rem;\n}\n\n.device-interactions__row-count {\n    display: block;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgb(245, 245, 245);\n    font-variant-numeric: tabular-nums;\n}\n\n.device-interactions__row-count-label {\n    display: block;\n    margin-top: 2px;\n    font-size: 0.62rem;\n    font-weight: 500;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.35);\n}\n\n.device-interactions__empty {\n    margin: 0;\n    padding: 24px;\n    text-align: center;\n    font-size: 0.9rem;\n    color: rgba(255, 255, 255, 0.45);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
